import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles(theme => ({
  paper: {
    padding: '12px 0px',
    backgroundColor: theme.palette.background.lightBlue,
    width: '270px',
    position: 'fixed',
    top: 0,
    left: '200px',
    height: '100vh'
  }
}));

const SidebarPopper = ({ children, isOpen, ...rest }) => {
  const classes = useStyles();
  return (
    <>
      {isOpen && (
        <Paper elevation={2} className={classes.paper} {...rest}>
          {children}
        </Paper>
      )}
    </>
  );
};

SidebarPopper.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool
};

SidebarPopper.defaultProps = {
  isOpen: false
};

export default SidebarPopper;
